// extracted by mini-css-extract-plugin
export default {"wrapper":"Task_wrapper__cgRjP","text":"Task_text__6oWNg","btn":"Task_btn__6JVep","checkbox":"Task_checkbox__IXvmD"};